import axios from "axios";
import { Empty } from "components/Empty";
import { FabricItem } from "components/FabricItem";
import { useOrderSample } from "hooks/useOrderSample";
import { useState, useEffect } from "react";

const Wishlist = ({ showNotification }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [items, setItems] = useState([]);

    const fetchWishlist = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get("/api/wishlist");
            if (response.status === 200) {
                setItems(response.data || []);
            }
        } catch (error) {
            console.error("Error loading wishlist:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const { orderSample, modalData, setModalData } = useOrderSample(setItems, async () => {
        await fetchWishlist();
        // @ts-ignore
        await updateBasket();
    });

    useEffect(() => {
        fetchWishlist();

        const handleAddToWishlist = (event) => {
            const { fabricId, needNotification } = event.detail;
            toggleWishlist(fabricId, needNotification);
        };

        window.addEventListener("addToWishlist", handleAddToWishlist);
        return () => {
            window.removeEventListener("addToWishlist", handleAddToWishlist);
        };
    }, []);

    const addToWishlist = async (fabricId, needNotification = true) => {
        try {
            const response = await axios.post(`/api/wishlist/${fabricId}`);

            if (response.status === 200 || response.status === 201) {

                if (needNotification) {
                    showNotification("Added to Wishlist");
                }

                await fetchWishlist();
            }
        } catch (error) {
            console.error("Error adding to wishlist:", error);
        }
};

    const removeFromWishlist = async (fabricId, needNotification = true) => {
        try {
            setItems(prev => prev.filter(item => item.pkFabricID != fabricId));

            const response = await axios.delete(`/api/wishlist/${fabricId}`);

            if (response.status === 200 || response.status === 204) {
                if (needNotification) {
                    showNotification("Removed from Wishlist");
                }
            }
        } catch (error) {
            console.error("Error removing from wishlist:", error);
            await fetchWishlist();
        }
    };

    const toggleWishlist = (fabricId, needNotification = true) => {
        setItems(prev => {
            const exists = prev.some(item => item.pkFabricID == fabricId);

            if (exists) {
                removeFromWishlist(fabricId, needNotification);
                return prev;
            } else {
                addToWishlist(fabricId, needNotification);
                return prev;
            }
        });
    };

    return (
        <>
        <div className="mt-54 sm-mt-32">
            {items.length > 0 ? (
                items.map(item => <FabricItem
                    inWishlist={item.inWishlist}
                    toggleAddedToWishlist={null}
                    mode="wishlist"
                    fabricUrl={item.fabricUrl}
                    collectionName={item.fabricCollectionName}
                    collectionUrl={item.collectionUrl}
                    displayPrice={item.displayPrice}
                    fullName={item.fabricFullName}
                    id={item.pkFabricID}
                    imagePath={item.imageFilePathName}
                    fabricInCart={item.inShoppingCart}
                    onRemove={removeFromWishlist}
                    orderSample={orderSample}
                    sampleInCart={item.sampleInShoppingCart}
                    samplesUnavailable={item.samplesUnavailable}
                    supplierId={item.pkFabricSupplierID}
                    supplySamples={item.supplySamples}
                    key={item.pkFabricID}
                />)
            ) : (<Empty isLoading={isLoading} mode={'wishlist'} />)}
        </div>

        {modalData && (
            <div
                className="overlay-with-box mobile-menu d-flex samples-overlay"
                onClick={(e) => { if (e.target.classList.contains('samples-overlay')) setModalData(null); }}
            >
                <div className="overlay-box active-group flex-column pb-70 fit-content black mobile-menu-container sm-px-12 react-overlay">
                    <div className="width-550 sm-max-w-100">
                        <div className="row mb-54 sm-mb-24">
                            <div className="col">
                                <h3 className="default-text" dangerouslySetInnerHTML={{ __html: modalData.title || '' }}></h3>
                            </div>
                            <div className="col-auto">
                                <span
                                    className="curtains-icon curtains-icon-close size-24 pointer"
                                    onClick={() => setModalData(null)}
                                ></span>
                            </div>
                        </div>

                        <div className="body-text3" dangerouslySetInnerHTML={{ __html: modalData.text || '' }}></div>

                        {modalData.imageUrl && (
                            <img
                                src={modalData.imageUrl}
                                alt={modalData.title}
                                className="mt-54 sm-mt-24"
                            />
                        )}
                    </div>
                </div>
            </div>
        )}
        </>
    );
};

export default Wishlist;